import { createSvgIcon } from '@material-ui/core';

export const LocalIcon = createSvgIcon(
  <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M28.1326 23C27.4301 23 26.7791 23.3686 26.4176 23.971L21.6174 31.971C21.2374 32.6044 21.2374 33.3956 21.6174 34.029L26.4176 42.029C26.7791 42.6314 27.4301 43 28.1326 43H37.8674C38.5699 43 39.2209 42.6314 39.5824 42.029L44.3826 34.029C44.7626 33.3956 44.7626 32.6044 44.3826 31.971L39.5824 23.971C39.2209 23.3686 38.5699 23 37.8674 23H28.1326Z"
      fill="currentColor"
    />
    <path
      d="M4.9519 4.99584C5.5614 4.35821 6.38805 4 7.25 4H20.25L30 14.2V20H26.75V15.9H18.625V7.4H7.25V34.6H18V38H7.25C6.38805 38 5.5614 37.6418 4.9519 37.0042C4.34241 36.3665 4 35.5017 4 34.6V7.4C4 6.49826 4.34241 5.63346 4.9519 4.99584Z"
      fill="currentColor"
    />
    <path d="M18 27.8V31.2H10.5V27.8H18Z" fill="currentColor" />
    <path d="M18 21V24.4H10.5V21H18Z" fill="currentColor" />
  </svg>,
  'LocalIcon',
);
